import { render, staticRenderFns } from "./KnSearcher.vue?vue&type=template&id=7c52c20c&"
import script from "./KnSearcher.vue?vue&type=script&lang=js&"
export * from "./KnSearcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports